import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Subject} from "rxjs";
import {Router} from "@angular/router";

@Component({
  selector: 'app-layout-steps',
  templateUrl: './layout-steps.component.html',
  styleUrls: ['./layout-steps.component.scss']
})
export class LayoutStepsComponent implements OnInit {
  @Input() steps: string[] = [];
  @Input() currentStep: number = 0;
  cnt=0;
  @Output() stepSelected = new EventEmitter<number>();
  @Output() goBack = new EventEmitter<void>();

  private _unsubscribeAll: Subject<any>;
  constructor(private router : Router) { }

  onStepClick(index: number): void {

    this.stepSelected.emit(index);
  }

  // Emits the goBack event
  onGoBack(): void {
    this.goBack.emit();
  }
  ngOnInit(): void {
  }

  retour() {
    this.router.navigate(['/produits-services']);
  }
  num(i:any)
  {
    i++;
    return "0"+i;
  }
  isStepsArray(): boolean {
    return Array.isArray(this.steps);
  }
}
